import { httpsCallable } from 'firebase/functions';
import i18n from '@/i18n';
import { functions } from '../firebase';

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  country: string;
  state: string;
  city: string;
  subject: string;
  subSpecialty: string;
  message: string;
  language?: 'en' | 'es';
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
  submissionId: string;
}

// Submit contact form via Cloud Function
export const submitContactForm = async (formData: ContactFormData): Promise<ContactFormResponse> => {
  try {
    const submitContactFormCallable = httpsCallable<ContactFormData, ContactFormResponse>(
      functions,
      'submitContactForm'
    );
    
    const result = await submitContactFormCallable({
      ...formData,
      language: i18n.language === 'en' ? 'en' : 'es',
    });
    return result.data;
  } catch (error: any) {
    console.error('Error submitting contact form:', error);
    
    // Handle Firebase Functions errors
    if (error.code) {
      switch (error.code) {
        case 'functions/invalid-argument':
          throw new Error(error.message || i18n.t('website.contact.errors.invalidData'));
        case 'functions/internal':
          throw new Error(error.message || i18n.t('website.contact.errors.server'));
        case 'functions/unauthenticated':
          throw new Error(i18n.t('website.contact.errors.authentication'));
        default:
          throw new Error(error.message || i18n.t('website.contact.errors.submit'));
      }
    }
    
    throw new Error(i18n.t('website.contact.errors.connection'));
  }
};
